<section class="d-flex flex-column sanofi-pagination flex-fill {{mix() ?? ''}}">
  <div class="container d-flex align-items-center justify-content-end px-0 pr-md-0 flex-wrap">
    <div class="d-flex col-12 col-md-9 px-0 justify-content-end align-items-center">
      <div class="sanofi-pagination__navigation mx-4">
        <span class="mr-1">{{ 'makeAPayment.pagination.page' | cxTranslate }}</span>
        <button class="sanofi-pagination__navigationBtn mr-1"
                (click)="previousPage()"
                [disabled]="currentPage() <= 0 || resultsLoading()"
                [class.sanofi-pagination__navigationBtn--disabled]="currentPage() <= 0 || resultsLoading()"
        >
          <cx-icon [type]="ICON_TYPE.CARET_LEFT" class="sanofi-pagination__navigationIcon"/>
        </button>
        @if (currentPage() > 0) {
          <span class="mr-1 sanofi-pagination__pageBtn" (click)="previousPage()">{{ currentPage() }} </span>
        }
        <span class="mx-1 font-bold">{{ currentPage() + 1 }}</span>

        @if (!noNextPage()) {
          <span class="mx-1 sanofi-pagination__pageBtn" (click)="nextPage()"> {{ currentPage() + 2 }}</span>
        }
        <button class="sanofi-pagination__navigationBtn ml-1"
                (click)="nextPage()"
                [disabled]="noNextPage()"
                [class.sanofi-pagination__navigationBtn--disabled]="noNextPage()">
          <cx-icon [type]="ICON_TYPE.CARET_RIGHT" class="sanofi-pagination__navigationIcon"/>
        </button>
      </div>
      <div class="">
        <ng-select
          name="pageSize"
          [searchable]="false"
          [clearable]="false"
          class="c-select page-size-select sanofi-pagination__PageSizeBtn"
          [(ngModel)]="currentPageSize"
          (change)="changePageSize($event)"
        >
          @for (size of pageSizeList(); track size) {
            <ng-option [value]="size">{{size}} {{ 'makeAPayment.pagination.perPage' | cxTranslate }}</ng-option>
          }
        </ng-select>
      </div>
    </div>
  </div>
</section>
